import { colors } from '@insurancemenu/imenu-components-lib';
import { IconCheckmark } from '@insurancemenu/imenu-components-lib/dist/icons';
import styled from 'styled-components';

export const CompletedCardWrapperStyled = styled.span`
  color: ${colors.green[600]};
  display: inline-flex;
  align-items: center;
`;

export const CardStatusTextStyled = styled.span`
  display: inline-flex;
  font-size: 1.2rem;
`;

export const CompletedIconStyled = styled(IconCheckmark)`
  margin-right: 0.4rem;
`;

export const ReadyToBeginStatusTextStyled = styled(CardStatusTextStyled)`
  color: ${colors.blue[600]};
`;

export const InProgressStatusTextStyled = styled(CardStatusTextStyled)`
  color: ${colors.orange[500]};
`;
